<script lang="ts">
    import {Spacer} from 'shared/layouts';
    import type {FieldTypeId} from 'src/typings';
    import type {FieldTypeDefinition} from 'src/features/record/field-types/types';
    import {type FilterSearchType, hasAnyFilterSearchFieldDefinition} from './types';
    import {getSearchFieldTypeFiltersContext} from './search-field-type-filters.context';
    import {onDestroy} from 'svelte';
    import {cleanup, exists} from 'shared/utils/custom-utils';
    import {getFieldTypeDefinitionRecursively} from 'src/features/record/field-types/utils';
    import FieldSortPopover from './sort/FieldSortPopover.svelte';
    import FieldFilterPopover from './filter/FieldFilterPopover.svelte';

    export let fieldTypeId: FieldTypeId;
    export let filterForceSearchType: FilterSearchType | null = null;

    const context = getSearchFieldTypeFiltersContext();

    let fieldDefinition: FieldTypeDefinition | null = null;
    const fieldTypeDefinitionsUnsubscribe = exists(context) ? context.fieldTypeDefinitions$.subscribe((currentFieldTypeDefinitions) => {
        if (exists(currentFieldTypeDefinitions)) {
            fieldDefinition = getFieldTypeDefinitionRecursively(currentFieldTypeDefinitions, fieldTypeId);
        }
    }) : undefined;

    onDestroy(() => {
        cleanup(fieldTypeDefinitionsUnsubscribe);
    });

    function isFilteringSupported(fieldDef: FieldTypeDefinition | null): boolean {
        return exists(fieldDef) && hasAnyFilterSearchFieldDefinition(fieldDef);
    }

    $: filteringSupported = isFilteringSupported(fieldDefinition);
    $: sortingSupported = exists(fieldDefinition) && exists(fieldDefinition.valueSorter);
</script>

{#if exists(context) && exists(fieldDefinition) && (sortingSupported || filteringSupported)}
    <span class="kp-search-field-type-filters">
        <slot/>

        <Spacer direction="horizontal" size="xs"/>

        {#if sortingSupported}
            <FieldSortPopover {fieldDefinition}/>
        {/if}

        {#if filteringSupported && hasAnyFilterSearchFieldDefinition(fieldDefinition)}
            <FieldFilterPopover {fieldDefinition} forceSearchType={filterForceSearchType}/>
        {/if}
    </span>
{:else}
    <span class="title-container">
        <slot/>
    </span>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-search-field-type-filters,
    .title-container {
        display: flex;
        align-items: center;
    }

    :global {
        .kp-search-field-type-filters {
            .kp-popover-panel .content {
                min-width: 250px;
            }

            .field-type-filter-button {
                font-size: @font-size-small;
                color: @themed-text-muted-label;
                transition: color 0.3s ease-in-out;

                &.filter-active {
                    color: var(--brand-orange);
                }
            }
        }
    }
</style>